export default "__VITE_PUBLIC_ASSET__249ac4c2__"